var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoneyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70478 3.4493C4.22466 3.32066 3.73116 3.60558 3.60251 4.0857L1.22138 12.9722C1.09273 13.4523 1.37765 13.9458 1.85777 14.0745L18.5632 18.5507C19.0433 18.6793 19.5368 18.3944 19.6655 17.9143L22.0466 9.02778C22.1753 8.54766 21.8903 8.05416 21.4102 7.92551L4.70478 3.4493ZM10.685 14.5417C12.6253 15.0616 14.623 13.8974 15.1472 11.9413C15.6713 9.98531 14.5233 7.97816 12.583 7.45827C10.6427 6.93838 8.64496 8.10261 8.12084 10.0587C7.59672 12.0147 8.74473 14.0218 10.685 14.5417Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08643 6.4C2.08643 5.90294 2.48937 5.5 2.98643 5.5H20.2812C20.7782 5.5 21.1812 5.90294 21.1812 6.4V15.6C21.1812 16.0971 20.7782 16.5 20.2812 16.5H2.98643C2.48937 16.5 2.08643 16.0971 2.08643 15.6V6.4ZM15.2709 11C15.2709 13.025 13.6425 14.6667 11.6338 14.6667C9.62509 14.6667 7.9967 13.025 7.9967 11C7.9967 8.97496 9.62509 7.33333 11.6338 7.33333C13.6425 7.33333 15.2709 8.97496 15.2709 11ZM11.6338 12.8333C12.6382 12.8333 13.4523 12.0125 13.4523 11C13.4523 9.98748 12.6382 9.16667 11.6338 9.16667C10.6294 9.16667 9.81525 9.98748 9.81525 11C9.81525 12.0125 10.6294 12.8333 11.6338 12.8333Z",
    fill: "#6C757D"
  })));
}

export default SvgMoneyIcon;